import { render } from "./plazosfacturacion.vue?vue&type=template&id=51e7c863"
import script from "./plazosfacturacion.vue?vue&type=script&lang=js"
export * from "./plazosfacturacion.vue?vue&type=script&lang=js"

import "./plazosfacturacion.vue?vue&type=style&index=0&id=51e7c863&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__